import { isServer } from 'app/libs/environment';

function checkIP(strIP) {
	const expUrl = /^(1|2)?\d?\d([.](1|2)?\d?\d){3}$/;
	return expUrl.test(strIP);
}

export function setCookie(cName, cValue, cDay, cHour, cMin, cSec) {
	if (isServer) return;

	const expire = new Date();
	let domain = window.location.hostname.split('.');

	if (domain[0] === 'localhost') {
		domain = '';
	} else if (checkIP(window.location.hostname)) {
		domain = window.location.hostname;
	} else {
		domain = `.${domain[domain.length - 2]}.${domain[domain.length - 1]}`;
	}

	let cookies = `${cName}=${encodeURIComponent(cValue)}; domain=${domain}; path=/;`;
	if (cDay) expire.setDate(expire.getDate() + cDay);
	if (cHour) expire.setHours(expire.getHours() + cHour);
	if (cMin) expire.setMinutes(expire.getMinutes() + cMin);
	if (cSec) expire.setSeconds(expire.getSeconds() + cSec);
	if (cDay || cHour || cMin || cSec) {
		cookies += ` expires=${expire.toGMTString()};`;
	}
	window.document.cookie = cookies;
}

export function getCookie(key, cookieStr) {
	const newKey = `${key}=`;
	const cookieData = cookieStr || global.document?.cookie || '';

	let start = cookieData.indexOf(newKey);
	let cValue = '';
	if (start !== -1) {
		start += newKey.length;
		let end = cookieData.indexOf(';', start);
		if (end === -1) {
			end = cookieData.length;
		}
		cValue = decodeURIComponent(cookieData.substring(start, end));
	}
	return cValue;
}

export function deleteCookie(cName) {
	setCookie(cName, '', -1);
}
